(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgEligFacilityDeleteController',ProgEligFacilityDeleteController);

    ProgEligFacilityDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProgEligFacility'];

    function ProgEligFacilityDeleteController($uibModalInstance, entity, ProgEligFacility) {
        var vm = this;

        vm.progEligFacility = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProgEligFacility.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
